module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-contact-contact"
  }, [_c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "lxm-contact-contact__item box",
    attrs: {
      "id": "contact-base"
    }
  }, [_c('article', {
    staticClass: "media"
  }, [_c('figure', {
    staticClass: "media-left"
  }, [_c('lxm-avatar', {
    attrs: {
      "size": '3.2143rem',
      "src": _vm.state.avatar,
      "name": _vm.state.name,
      "isFemale": _vm.state.isFemale
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "lxm-contact-contact__line",
    style: (_vm.marginPhoneBottom(_vm.state))
  }, [_c('img', {
    staticClass: "lxm-contact-contact__item-phone-icon",
    attrs: {
      "src": require("../../../images/main/contact/phone.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.state.phone))])]), _vm._v(" "), (_vm.state.phone2 && _vm.state.phone != _vm.state.phone2) ? _c('div', {
    staticClass: "lxm-contact-contact__line lxm-contact-contact__line_align",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.state.phone2))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lxm-contact-contact__line",
    style: (_vm.marginMailBottom(_vm.state))
  }, [_c('img', {
    staticClass: "lxm-contact-contact__item-mail-icon",
    attrs: {
      "src": require("../../../images/main/contact/mail.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.state.mail))])]), _vm._v(" "), (_vm.state.mail2 && _vm.state.mail != _vm.state.mail2) ? _c('div', {
    staticClass: "lxm-contact-contact__line lxm-contact-contact__line_align"
  }, [_c('span', [_vm._v(_vm._s(_vm.state.mail2))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "lxm-contact-contact__tabs"
  }, [_c('lxm-tabs', {
    attrs: {
      "tabs": _vm.tabs
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lxm-transition",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7bca3120", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7bca3120!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Contact/Contact/index.vue
// module id = 873
// module chunks = 0